<template>
    <div class="root_page_center wrapper_setting">
        <div class="header_identi">
            <div class="">
                <img src="../assets/images/back1.png" @click="backPage()" alt="btn back" class="btn_back" title="Back">
                <h3 class="title_header_iden">Định danh doanh nghiệp</h3>
                <router-link to="/" class="btnHome_right">
                    <img src="../assets/images/home.png" alt="btn home" class="btn_back_home" title="Trang chủ">
                </router-link>
                <img src="../assets/images/qr4.png" @click="loadpageEnd()" alt="btn qr" class="btn_qr_redirect" title="QR">
            </div>
        </div>
        <div class="wrapper_identifier">
            <!-- Page 1 -->
            <div class="page_one" v-if="checkForm == 1">
                <div class="wp_txt_img">
                    <h3>Đặt CCCD dọc theo màn hình điện thoại để tiến hành định danh</h3>
                    <div class="img_scan">
                        <img src="../assets/images/scan.png" alt="">
                        <!-- <div class="scan-line" :class="gradientClass" @animationiteration="toggleDirection"></div> -->
                        <div class="scan-line" :class="gradientClass" :style="{ animation: currentAnimation }" @animationend="onAnimEnd"></div>
                    </div>
                </div>
                <div class="btn_continute">
                    <button type="button" @click="startIdentifier()">Bắt đầu</button>
                </div>
            </div>
            <!-- Page 2 -->
            <div class="page_two" v-else-if="checkForm == 2">
                <div class="wp_txt_img">
                    <h3>Đặt CCCD dọc theo màn hình điện thoại để tiến hành định danh</h3>
                    <div class="frm_scan_cccd">
                        <div class="img_scan">
                            <img src="../assets/images/scan.png" alt="">
                            <div class="scan-line" :class="gradientClass" :style="{ animation: currentAnimation }" @animationend="onAnimEnd"></div>
                        </div>
                        <div :class="'wp_txt_bottom ' + cl_click">
                            <div class="loading_scan">
                                <div class="dots">
                                    <span v-for="(dot, index) in dots" :key="index" :class="{ active: index < currentIndex }" class="dot"></span>
                                </div>
                                <h4>Đang quét thông tin thẻ căn cước...</h4>
                            </div>
                            <div class="text_scan_page">
                                <p>Lưu ý: Hệ thống đang xác thực thông tin vui lòng không nhấc thẻ căn cước cho đến khi hoàn tất quá trình xử lý!</p>
                            </div>
                        </div>
                        <div class="btn_continute btn_continute_step2">
                            <button type="button" @click="startStep3()">Tiếp tục</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page 3 -->
            <div class="page_three" v-else-if="checkForm == 3">
                <div class="content_qraccount">
                    <div class="img_nameCompany">
                        <div class="img_company">
                            <img src="../assets/images/logo3.png" alt="">
                        </div>
                        <div class="name_company name_full">
                            {{ infoPage.name }}
                        </div>
                    </div>
                    <div class="item_detail_company">
                        <p>Số CCCD: <span>{{ infoPage.identity_number }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Ngày sinh: <span>{{ formatDate(infoPage.dob) }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Giới tính: <span>{{ infoPage.gender }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Quốc tịch: <span>{{ infoPage.nationality }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Nơi thường trú: <span>{{ infoPage.permanent_address }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Ngày cấp: <span>{{ formatDate(infoPage.issue_date) }}</span></p>
                    </div>
                    <div class="item_detail_company item_detail_company_pg">
                        <p>Nơi cấp: <span>{{ infoPage.issue_place }}</span></p>
                    </div>
                    <div class="code_qr_account">
                        <h2 class="code_iden" v-if="infoPage.identifier != null">
                            <span v-for="(c, i) in infoPage.identifier" :key="i">{{ c }}</span>
                        </h2>
                        <div class="img_qr_account" v-if="infoPage.qr_identity != null">
                            <img :src="infoPage.qr_identity" alt="">
                        </div>
                    </div>
                    <div class="btn_continute">
                        <button type="button" @click="startProfile()">Tiếp tục</button>
                    </div>
                </div>
            </div>
            <!-- Page 4 -->
            <div class="page_four" v-else-if="checkForm == 4">
                <div class="wp_txt_img">
                    <h3>Đưa mặt vào khung hình</h3>
                    <div class="frm_scan_cccd">
                        <div class="camera-page">
                            <video ref="videos" autoplay playsinline class="camera-view_page_four" />
                            <!-- <div class="face-page"></div> -->
                            <div class="scan-line"></div>
                            <button class="capture-btn capture-btn_pg_four" @click.prevent="captures" v-if="checkImgs == 0">Chụp ảnh</button>
                            <div v-if="capturedImages" class="preview_cc_page_four">
                                <img :src="capturedImages" alt="Ảnh chụp" />
                            </div>
                            <img src="../assets/images/ss.png" alt="" class="ss_done" v-if="varSS == 1">
                            <img src="../assets/images/fl.png" alt="" class="ss_done" v-if="varSS == 2">
                        </div>
                        <div :class="'wp_txt_bottom ' + cl_clicks">
                            <div class="loading_scan">
                                <div class="dots">
                                    <span v-for="(dot, index) in dots" :key="index" :class="{ active: index < currentIndexs }" class="dot"></span>
                                </div>
                                <h4>Đang xác minh khuôn mặt...</h4>
                            </div>
                            <div class="text_scan_page">
                                <p>Lưu ý: Đặt thẻ căn cước lên màn hình ngay khi có chữ Hoàn Thành</p>
                            </div>
                            <div class="btn_continute btn_continute_step2" v-if="checkImgCamera == 1 && checkMobileDevice()">
                                <button type="button" @click="openCamera()">Mở camera</button>
                            </div>
                        </div>
                        <div class="btn_continute btn_continute_step2" v-if="checkBtn == 1">
                            <button type="button" @click="startStep5()">Tiếp tục</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page 5 -->
            <div class="page_five" v-else>
                <div class="content_qraccount">
                    <div class="img_nameCompany">
                        <div class="img_company">
                            <img src="../assets/images/logos.png" alt="">
                        </div>
                        <div class="name_company">
                            {{ infoPageEnd.company_name }}
                        </div>
                    </div>
                    <div class="item_detail_company">
                        <p>Người đại diện: <span>{{ infoPageEnd.representative_name }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Mã số thuế: <span>{{ infoPageEnd.tax_code }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Số điện thoại: <span>{{ infoPageEnd.phone }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Ngày thành lập: <span>{{ infoPageEnd.establishment_date }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Địa chỉ đăng ký: <span>{{ infoPageEnd.address_detail }}</span></p>
                    </div>
                    <div class="item_detail_company">
                        <p>Số tài khoản: <span>{{ infoPageEnd.bank_account_number }}</span></p>
                    </div>
                    <div class="item_detail_company item_detail_company_pg">
                        <p>Mã định danh: <span class="code_identifier">{{ infoPageEnd.identifier }}</span></p>
                    </div>
                    <div class="text_bank_page">
                        <h5>Doanh nghiệp thực hiện liên kết mã QR Công Ty đã được định danh vào</h5>
                        <h6>{{ infoPageEnd.bank_name }}</h6>
                        <p>để hoàn tất hồ sơ đã đăng ký</p>
                    </div>
                    <div class="code_qr_account" v-if="infoPageEnd.qr_user != null">
                        <div class="img_qr_account">
                            <img :src="linkWebAdmin + infoPageEnd.qr_user" alt="">
                        </div>
                    </div>
                    <div class="btn_continute">
                        <button type="button" @click="loadAppBank()">Xác nhận</button>
                    </div>
                </div>
            </div>
            <!-- Modal feild -->
            <div class="modal_feild" v-if="showmodal">
                <div class="content_feild">
                    <div class="wp_feild">
                        <h3>Không thành công</h3>
                        <div class="img_feild">
                            <img src="../assets/images/4.png" alt="">
                        </div>
                        <h5>Không nhấc thẻ căn cước <br /> ra khỏi màn hình khi hệ thống <br />đang đọc dữ liệu</h5>
                        <div class="pont_red">
                            <ul>
                                <li v-for="n in 7" :key="n"><img src="../assets/images/5.png" alt=""></li>
                            </ul>
                        </div>
                        <div class="btn_feild">
                            <button type="button" @click="StartCCCD()">Quét lại</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SocketIO from 'socket.io-client'
export default {
    name: 'Identifier_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            checkForm: 1,
            checkImg: 0,
            checkBtn: 0,
            capturedImage: null,
            capturedImages: null,
            checkImgs: 0,
            hideRun: 0,
            orther: [],
            dots: Array(7).fill(0),
            currentIndex: 0,
            currentIndexs: 0,
            timer: null,
            timers: null,
            stopAt: 5,
            cl_click: '',
            cl_clicks: '',
            identity: '',
            portrait: '',
            infoPage: [],
            stream: null,
            streams: null,
            infoPageEnd: [],
            varSS: 0,
            socket: null,
            showmodal: false,
            gradientClass: 'top',
            currentAnimation: "moveDown 4s linear forwards",
            checkImgCamera: 0
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.socketEventCheckIden()
        this.getDataInfo()
        this.postPageStep()
    },
    beforeUnmount () {
        clearInterval(this.timer)
        clearInterval(this.timers)
        if (this.socket) {
            this.socket.disconnect()
        }
    },
    methods: {
        // toggleDirection() {
        //     this.gradientClass = this.gradientClass == 'top' ? 'bottom' : 'top';
        // },
        onAnimEnd() {
            if (this.currentAnimation.includes("moveDown")) {
                this.gradientClass = "bottom";
                this.currentAnimation = "moveUp 4s linear forwards";
            }
            else {
                this.gradientClass = "top";
                this.currentAnimation = "moveDown 4s linear forwards";
            }
        },
        backPage () {
            if(this.checkForm == 1){
                this.$router.push('/')
            }else{
                const form = new FormData();
                form.append('identity', '');
                form.append('portrait', '');
                form.append('start_page', this.checkForm - 1);
                this.axios.post(this.api_updateIdentifier,
                    form,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.token
                        }
                    }
                ).then((response) => {
                    this.orther = response
                })
                if(this.checkForm == 2){
                    this.gradientClass = 'top',
                    this.currentAnimation = "moveDown 4s linear forwards"
                    this.checkForm = this.checkForm - 1
                    this.checkImg = 0
                    this.cl_click = ''
                    this.capturedImage = null
                    clearInterval(this.timer)
                    this.currentIndex = 0
                }else if(this.checkForm == 3){
                    this.checkForm = this.checkForm - 1
                    this.checkImg = 0
                    this.cl_click = ''
                    this.capturedImage = null
                    clearInterval(this.timer)
                    this.currentIndex = 0
                    this.startAnimation()
                }else if(this.checkForm == 4){
                    this.checkForm = this.checkForm - 1
                    this.checkImgs = 0
                    this.cl_clicks = ''
                    this.capturedImages = null
                    this.varSS = 0
                    clearInterval(this.timers)
                    this.currentIndexs = 0
                }else{
                    this.checkBtn = 0
                    this.checkForm = this.checkForm - 1
                    this.checkImgs = 0
                    this.cl_clicks = ''
                    this.capturedImages = null
                    this.varSS = 0
                    this.initCameras()
                    clearInterval(this.timers)
                    this.currentIndexs = 0
                }
            }
        },
        startIdentifier () {
            this.gradientClass = 'top',
            this.currentAnimation = "moveDown 4s linear forwards"
            const form = new FormData();
            form.append('identity', '');
            form.append('portrait', '');
            form.append('start_page', 2);
            this.axios.post(this.api_updateIdentifier,
                form,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.orther = response
            })
            this.checkForm = 2
            this.startAnimation()
        },
        startProfile () {
            this.checkForm = 4
            this.postPageStep()
            this.initCameras()
        },
        async initCameras() {
            try {
                this.streams = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: 'user' }
                })
                this.$refs.videos.srcObject = this.streams
                this.checkImgCamera = 0
            } catch (err) {
                this.checkImgCamera = 1
                console.log('Không thể truy cập camera: ' + err.message)
            }
        },
        captures() {
            this.checkImgCamera = 0
            this.cl_clicks = 'active'
            const video = this.$refs.videos
            const w = 435
            const h = 613
            const canvas = document.createElement('canvas')
            canvas.width = w
            canvas.height = h
            const ctx = canvas.getContext('2d')
            const vW = video.videoWidth
            const vH = video.videoHeight
            const scale = Math.max(w / vW, h / vH)
            const scaledW = vW * scale
            const scaledH = vH * scale
            const offsetX = (w - scaledW) / 2
            const offsetY = (h - scaledH) / 2
            ctx.drawImage(video, offsetX, offsetY, scaledW, scaledH)

            this.capturedImages = canvas.toDataURL('image/png')
            this.portrait = this.dataURLtoFile(this.capturedImages, 'identity.png')
            if (this.capturedImages) {
                this.checkBtn = 1
                this.checkImgs = 1
                const form = new FormData();
                form.append('identity', '');
                form.append('portrait', this.portrait);
                this.axios.post(this.api_updateIdentifier,
                    form,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.token
                        }
                    }
                ).then((response) => {
                    this.infoPageEnd = response.data.user
                }).catch(e => {
                    this.orther = e
                })
                this.startAnimations()
            }
        },
        startAnimation() {
            this.timer = setInterval(() => {
                if (this.currentIndex < this.stopAt) {
                    this.currentIndex++
                } else {
                    clearInterval(this.timer)
                }
            }, 200)
        },
        startAnimations() {
            this.timers = setInterval(() => {
                if (this.currentIndexs < this.stopAt) {
                    this.currentIndexs++
                } else {
                    clearInterval(this.timers)
                }
            }, 200)
        },
        resumeAnimation(finalIndex = 7) {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.currentIndex < finalIndex) {
                    this.currentIndex++
                } else {
                    clearInterval(this.timer)
                }
            }, 200)
        },
        resumeAnimations(finalIndexs = 7) {
            clearInterval(this.timers)
            this.timers = setInterval(() => {
                if (this.currentIndexs < finalIndexs) {
                    this.currentIndexs++
                } else {
                    clearInterval(this.timers)
                }
            }, 200)
        },
        dataURLtoFile(dataURL, filename) {
            const arr = dataURL.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        formatDate(date) {
            if (!date) return ''
            let allDate = date.split('-')
            return `${allDate[2]}/${allDate[1]}/${allDate[0]}`
        },
        socketEventCheckIden () {
            let thiss = this
            var idUser = window.localStorage.getItem('idUser')
            this.socket = SocketIO(this.linkWebAdmin, { transports: ['websocket', 'polling', 'flashsocket'], reconnection: true, reconnectionAttempts: 5, reconnectionDelay: 2000 });
            this.socket.on(`laravel_database_identity.${idUser}:update-image-status`, function(result) {
                // console.log(result.data);
                if(result.data.type == "step1"){
                    if(result.data.status == true){
                        if(thiss.checkForm == 1){
                            thiss.checkForm = 2
                            thiss.postPageStep()
                            thiss.startAnimation()
                        }
                    }
                } else if(result.data.type == "step2") {
                    if(result.data.status == true){
                        if(thiss.checkForm == 2){
                            thiss.resumeAnimation(7)
                            setTimeout(() => {
                                thiss.checkForm = 3
                                thiss.postPageStep()
                            }, 800);
                        }
                    }else{
                        thiss.checkImg = 0
                        thiss.cl_click = ''
                        thiss.capturedImage = null
                        clearInterval(thiss.timer)
                        thiss.currentIndex = 0
                        thiss.showmodal = true
                    }
                } else if(result.data.type == "step3") {
                    if(result.data.status == true){
                        if(thiss.checkForm == 3){
                            thiss.checkForm = 4
                            thiss.postPageStep()
                            thiss.initCameras()
                        }
                    }else{
                        thiss.checkImg = 0
                        thiss.cl_click = ''
                        thiss.capturedImage = null
                        clearInterval(thiss.timer)
                        thiss.currentIndex = 0
                        thiss.showmodal = true
                    }
                } else if(result.data.type == "step4") {
                    if(result.data.status == true){
                        if(thiss.checkForm == 4){
                            thiss.resumeAnimations(7)
                            setTimeout(() => {
                                thiss.varSS = 1
                            }, 800);
                            setTimeout(() => {
                                thiss.checkForm = 5
                                thiss.postPageStep()
                            }, 2000);
                        }
                    }else{
                        thiss.varSS = 2
                        setTimeout(() => {
                            thiss.varSS = 0
                        }, 3000);
                        thiss.checkImgs = 0
                        thiss.cl_clicks = ''
                        thiss.capturedImages = null
                        clearInterval(thiss.timers)
                        thiss.currentIndexs = 0
                        setTimeout(() => {
                            thiss.showmodal = true
                        }, 4000);
                    }
                } else if(result.data.type == "step5") {
                    if(result.data.status == true){
                        if(thiss.checkForm == 5){
                            const ua = navigator.userAgent.toLowerCase();
                            const deepAndroid = thiss.infoPageEnd.deep_android;
                            const deepIos = thiss.infoPageEnd.deep_ios;
                            const linkAndroid = thiss.infoPageEnd.link_android;
                            const linkIos = thiss.infoPageEnd.link_ios;
                            if (/android/.test(ua)) {
                                window.location.href = deepAndroid;
                                setTimeout(() => {
                                    window.location.href = linkAndroid;
                                }, 2000);
                                return;
                            }
                            else if (/iphone|ipad|ipod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
                                window.location.href = deepIos;
                                setTimeout(() => {
                                    window.location.href = linkIos;
                                }, 2500);
                                return;
                            }
                            else {
                                window.open(linkAndroid, "_blank");
                                return;
                            }
                        }
                    }else{
                        thiss.showmodal = true
                    }
                } else {
                    if(result.data.status == true){
                        if(thiss.checkForm == 4){
                            thiss.resumeAnimations(7)
                            setTimeout(() => {
                                thiss.varSS = 1
                            }, 800);
                        }
                    }else{
                        thiss.varSS = 2
                        setTimeout(() => {
                            thiss.varSS = 0
                        }, 3000);
                        thiss.checkImgs = 0
                        thiss.cl_clicks = ''
                        thiss.capturedImages = null
                        clearInterval(thiss.timers)
                        thiss.currentIndexs = 0
                    }
                }
            });
        },
        loadAppBank () {
            const ua = navigator.userAgent.toLowerCase();
            const deepAndroid = this.infoPageEnd.deep_android;
            const deepIos = this.infoPageEnd.deep_ios;
            const linkAndroid = this.infoPageEnd.link_android;
            const linkIos = this.infoPageEnd.link_ios;
            if (/android/.test(ua)) {
                window.location.href = deepAndroid;
                setTimeout(() => {
                    window.location.href = linkAndroid;
                }, 2000);
                return;
            }
            else if (/iphone|ipad|ipod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
                window.location.href = deepIos;
                setTimeout(() => {
                    window.location.href = linkIos;
                }, 2500);
                return;
            }
            else {
                window.open(linkAndroid, "_blank");
                return;
            }
        },
        checkMobileDevice() {
            const ua = navigator.userAgent.toLowerCase();
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const isMobile = /android|iphone|ipad|ipod|tablet|mobile/.test(ua);
            const isDesktop = !hasTouch && !isMobile;
            return !isDesktop;
        },
        loadpageEnd () {
            this.checkForm = 5
            this.postPageStep()
        },
        getDataInfo () {
            const form = new FormData();
            form.append('identity', '');
            form.append('portrait', '');
            this.axios.post(this.api_updateIdentifier,
                form,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.infoPageEnd = response.data.user
                this.infoPage = response.data.user
            }).catch(e => {
                this.orther = e
            })
        },
        StartCCCD () {
            this.showmodal = false
            this.gradientClass = 'top',
            this.currentAnimation = "moveDown 4s linear forwards"
            this.checkForm = 2
            this.postPageStep()
            clearInterval(this.timer)
            clearInterval(this.timers)
            this.currentIndex = 0
            this.currentIndexs = 0
            this.varSS = 0
            this.checkImgs = 0
            this.cl_clicks = ''
            this.capturedImages = null
            this.startAnimation()
        },
        postPageStep () {
            const form = new FormData();
            form.append('identity', '');
            form.append('portrait', '');
            form.append('start_page', this.checkForm);
            this.axios.post(this.api_updateIdentifier,
                form,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.orther = response
            })
        },
        startStep3 () {
            this.resumeAnimation(7)
            setTimeout(() => {
                this.checkForm = 3
                this.postPageStep()
            }, 800);
        },
        startStep5 () {
            this.resumeAnimations(7)
            setTimeout(() => {
                this.checkForm = 5
                this.postPageStep()
            }, 800);
        },
        openCamera () {
            this.initCameras()
        }
    }
}
</script>